export const GROUP_KEYS = {
  RECENTLY_USED_GROUPS: "picoRecentlyUsedGroups",
};
